import script from "./ProductionTreeview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionTreeview.vue?vue&type=script&setup=true&lang=js"

import "./ProductionTreeview.vue?vue&type=style&index=0&id=77f565a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f565a6"]])

export default __exports__